import { motion } from "framer-motion";
import { Brain, Shield, Cpu, Zap } from "lucide-react";

export const AITechnologiesSection = () => {
  return (
    <section className="py-20 sm:py-24 bg-[#F5F5F7]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid gap-16 lg:grid-cols-2">
          {/* Vertical AI Section */}
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-8"
          >
            <div className="space-y-4">
              <h2 className="apple-heading text-2xl sm:text-3xl md:text-4xl tracking-tight">
                <span className="ai-term break-words">Vertical AI</span> Technology
              </h2>
              <p className="apple-subheading text-lg leading-relaxed text-[#86868b]">
                Our specialized AI system is built specifically for cognitive health monitoring,
                offering unparalleled accuracy and insights in memory care.
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Brain className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="apple-heading text-xl mb-2">Domain Expertise</h3>
                  <p className="apple-subheading text-[#86868b]">
                    Purpose-built algorithms specifically trained on cognitive health data,
                    ensuring higher accuracy and more relevant insights.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Shield className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="apple-heading text-xl mb-2">Healthcare-Grade Security</h3>
                  <p className="apple-subheading text-[#86868b]">
                    HIPAA-compliant infrastructure with enterprise-level security measures
                    to protect sensitive health data.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Agentic AI Section */}
          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-8"
          >
            <div className="space-y-4">
              <h2 className="apple-heading text-3xl sm:text-4xl tracking-tight">
                <span className="ai-term">Guided-Agentic AI</span> Capabilities
              </h2>
              <p className="apple-subheading text-lg leading-relaxed text-[#86868b]">
                Proactive AI agents that continuously monitor, learn, and adapt to provide
                personalized care recommendations and early detection.
              </p>
            </div>

            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Cpu className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="apple-heading text-xl mb-2">Autonomous Learning</h3>
                  <p className="apple-subheading text-[#86868b]">
                    Self-improving algorithms that continuously learn from new data to enhance
                    detection accuracy and personalization.
                  </p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 rounded-2xl bg-primary/10 flex items-center justify-center flex-shrink-0">
                  <Zap className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h3 className="apple-heading text-xl mb-2">Proactive Monitoring</h3>
                  <p className="apple-subheading text-[#86868b]">
                    Real-time analysis and early warning system that identifies potential
                    cognitive changes before they become apparent.
                  </p>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};